import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AudiosRoutingModule } from './audios-routing.module';
import { AudiosComponent } from './audios.component';


@NgModule({
  declarations: [
    AudiosComponent
  ],
  imports: [
    CommonModule,
    AudiosRoutingModule
  ],
    exports:[
      AudiosComponent
    ]
})
export class AudiosModule { }
